import styled, { css } from "styled-components";

import { EDIT_PAGE_FORM_WIDTH } from "../../constants/form";

const ScrollBarMixin = css`
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
    bottom: 0;
    left: 0;
    position: absolute;
    top: 0;
    right: 0;
  }

  ::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
  }

  ::-webkit-scrollbar-thumb {
    background-color: hsla(0, 0%, 0%, 0.2);
    background-clip: padding-box;
    border: 2px solid rgba(0, 0, 0, 0);
    border-radius: 6px;
    min-height: 15px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: hsla(0, 0%, 0%, 0.35);
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const ChartContainer = styled.div`
  flex-grow: 1;
  height: 100%;
`;

export const FormContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  padding-right: 8px;
  padding-bottom: 56px;
  width: ${`${EDIT_PAGE_FORM_WIDTH}px`};
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  flex-shrink: 0;
  ${ScrollBarMixin};
`;

export const FixedButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 296px;
  height: 56px;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
  padding-right: 16px;
  padding-top: 8px;
  background-color: #fff;

  & > button {
    width: 96px;
    height: 32px;
  }
`;

export const ButtonMixin = css`
  width: 96px;
  height: 32px;
`;
// export const SubmitButton = styled.div``;
